module.exports = __webpack_public_path__ + "static/media/phones.46600549.jpg";